import { render, staticRenderFns } from "./DocWidget.vue?vue&type=template&id=6aa8424b&scoped=true"
import script from "./DocWidget.vue?vue&type=script&lang=js"
export * from "./DocWidget.vue?vue&type=script&lang=js"
import style0 from "./DocWidget.vue?vue&type=style&index=0&id=6aa8424b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8424b",
  null
  
)

export default component.exports